<template>
  <div id="page-container" class="side-trans-enabled">
    <!-- Main Container -->
    <main id="main-container">
      <!-- Page Content -->
      <div
        class="bg-image"
        style="
          background-image: url('https://images.unsplash.com/photo-1473448912268-2022ce9509d8?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=1925&amp;q=80');
        "
      >
        <div class="row no-gutters bg-primary-op">
          <!-- Meta Info Section -->
          <div class="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center"></div>
          <!-- END Meta Info Section -->

          <!-- Main Section -->
          <div class="hero-static col-md-6 d-flex flex-column align-items-center bg-white">
            <!-- Header -->
            <div class="w-100 py-5 bg-white text-center">
              <a class="img-fluid" href="/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="30%"
                  viewBox="0 0 858 140"
                  data-v-c4edd37a=""
                >
                  <path
                    fill-rule="evenodd"
                    fill="rgb(101, 193, 152)"
                    d="M0.0,0.0 C27.866,0.0 55.740,0.0 83.607,0.0 C83.607,7.790 83.607,15.584 83.607,23.374 C64.877,23.374 46.141,23.374 27.412,23.374 C27.412,32.82 27.412,40.792 27.412,49.499 C42.944,49.499 58.480,49.499 74.12,49.499 C74.12,57.291 74.12,65.83 74.12,72.874 C58.479,72.874 42.945,72.874 27.412,72.874 C27.412,81.124 27.412,89.375 27.412,97.624 C46.141,97.624 64.877,97.624 83.607,97.624 C83.607,105.416 83.607,113.208 83.607,120.999 C55.737,120.999 27.868,120.999 0.0,120.999 C0.0,80.670 0.0,40.329 0.0,0.0 ZM94.571,0.0 C127.463,0.0 160.364,0.0 193.255,0.0 C193.255,7.790 193.255,15.584 193.255,23.374 C181.378,23.374 169.497,23.374 157.619,23.374 C157.619,55.913 157.619,88.461 157.619,120.999 C148.483,120.999 139.344,120.999 130.207,120.999 C130.207,88.461 130.207,55.913 130.207,23.374 C118.330,23.374 106.449,23.374 94.571,23.374 C94.571,15.584 94.571,7.790 94.571,0.0 ZM248.79,0.0 C270.466,40.333 292.852,80.666 315.239,120.999 C305.188,120.999 295.137,120.999 285.86,120.999 C273.665,99.918 262.241,78.831 250.821,57.749 C250.364,57.749 249.907,57.749 249.450,57.749 C238.29,78.831 226.605,99.918 215.185,120.999 C204.221,120.999 193.254,120.999 182.290,120.999 C204.218,80.670 226.152,40.329 248.79,0.0 ZM330.316,0.0 C339.452,0.0 348.591,0.0 357.728,0.0 C357.728,40.333 357.728,80.666 357.728,120.999 C348.591,120.999 339.453,120.999 330.316,120.999 C330.316,80.666 330.316,40.333 330.316,0.0 ZM468.747,0.0 C477.884,0.0 487.23,0.0 496.159,0.0 C496.159,40.329 496.159,80.670 496.159,120.999 C467.379,98.543 438.591,76.81 409.811,53.624 C409.811,76.81 409.811,98.543 409.811,120.999 C400.674,120.999 391.536,120.999 382.399,120.999 C382.399,80.666 382.399,40.333 382.399,0.0 C411.182,22.458 439.964,44.916 468.747,67.374 C468.747,44.918 468.747,22.456 468.747,0.0 ZM773.22,0.0 C782.158,0.0 791.297,0.0 800.434,0.0 C800.434,32.538 800.434,65.86 800.434,97.624 C819.621,97.624 838.813,97.624 857.999,97.624 C857.999,105.415 857.999,113.209 857.999,120.999 C829.676,120.999 801.345,120.999 773.22,120.999 C773.22,80.670 773.22,40.329 773.22,0.0 ZM659.261,0.0 L712.715,0.0 C712.715,0.0 723.166,0.92 730.533,6.874 C737.109,12.16 742.385,20.839 742.868,30.249 C743.352,39.660 742.587,47.307 738.757,54.999 C747.148,60.363 751.630,71.751 751.944,83.323 C752.153,91.16 750.282,103.976 740.127,112.749 C732.101,119.684 722.732,120.593 715.456,120.999 C715.472,121.11 659.261,120.999 659.261,120.999 L659.261,0.0 ZM683.932,23.374 C683.932,31.166 683.932,38.958 683.932,46.749 C693.527,46.749 703.121,46.749 712.715,46.749 C712.715,46.749 715.190,44.723 716.827,42.624 C719.969,38.377 720.27,31.661 716.827,27.499 C715.786,25.850 712.715,23.374 712.715,23.374 C703.121,23.374 693.527,23.374 683.932,23.374 ZM683.932,70.124 C683.932,79.291 683.932,88.458 683.932,97.624 L718.198,97.624 C718.198,97.624 722.102,95.899 725.51,92.124 C727.999,88.350 727.956,81.210 725.51,75.624 C723.424,72.496 718.902,70.115 718.198,70.124 C706.776,70.124 695.354,70.124 683.932,70.124 Z"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    fill="rgb(39, 58, 74)"
                    d="M577.25,0.0 C577.83,0.24 593.492,30.182 593.472,30.249 C588.549,39.494 583.589,48.538 578.396,57.749 C580.945,53.228 556.575,95.471 542.760,120.999 C532.252,120.999 521.744,120.999 511.236,120.999 C533.166,80.666 555.95,40.333 577.25,0.0 Z"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    fill="rgb(101, 193, 152)"
                    d="M600.0,42.999 C599.942,43.24 582.980,69.932 583.0,69.999 C590.221,83.559 599.502,99.310 611.239,120.999 C621.747,120.999 632.255,120.999 642.763,120.999 C620.833,80.666 621.929,83.333 600.0,42.999 Z"
                  ></path>
                </svg>
              </a>
            </div>
            <!-- END Header -->
            <div class="row justify-content-center flex-row flex-grow-1 w-100">
              <div class="col-sm-8 col-xl-6 align-self-center">
                <h3 class="text-muted mb-2">Forbidden</h3>
                <h1>You are not allowed to view this page...</h1>
              </div>
            </div>
            <!-- Footer -->
            <div class="w-100 p-5 bg-white">
              <a class="btn btn-text" href="/"> Dashboard </a>
              <a class="btn btn-text" href="/"> Support </a>
            </div>
            <!-- END Footer -->
          </div>
          <!-- END Main Section -->
        </div>
      </div>
      <!-- END Page Content -->
    </main>
    <!-- END Main Container -->
  </div>
</template>
<script>
export default {
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
